<template>
  <ul class="social reset-list d-flex mx-n75 xx-large:mx-n100">
    <li
      class="social__item mx-75 xx-large:mx-100"
      v-for="(item, index) in links"
      :key="index"
    >
      <a
        class="social__link hover:text-primary"
        style="font-size: 20px"
        :href="item.url"
        target="_blank"
        :aria-label="item.title"
      >
        <span
          class="sidearm-icon reset-icon social__text"
          :class="item.icon"
          aria-hidden="true"
        ></span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: "Social",

  data() {
    return {
      links: [
        {
          title: "Twitter",
          icon: "sf-twitter",
          url: "https://twitter.com/thefanexam",
        },
        {
          title: "Facebook",
          icon: "sf-facebook-2",
          url: "https://www.facebook.com/thefanexam",
        },
        {
          title: "Instagram",
          icon: "sf-instagram",
          url: "https://www.instagram.com/thefanexam",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.social {
  &__text {
    color: var(--color-text-on-dark);
  }
  @media screen and (max-width: 1023px) {
    &__item {
      flex: 1 0 0px;
      &:not(:first-child) {
        border-left: 1px solid var(--color-dark);
      }
    }
    &__link {
      align-items: center;
      display: flex;
      height: 48px;
      justify-content: center;
    }
  }
  @media screen and (min-width: 1024px) {
    &__text {
      color: var(--color-text-on-primary);
    }
    &__link {
      transition: all 0.15s;
      &:hover {
        color: var(--color-secondary);
      }
    }
  }
}
</style>
